import { cB, cM } from '../../../_utils/cssr'

export default cB('input-number', [
  cM('rtl', `
    direction: rtl;
  `)
])
